import { useEffect, useRef } from "react";

import { reportUnrecognizedNotificationEventType } from "./inbox-adapter";

export type UnrecognizedNotificationEvent = { eventType: string; itemId?: string };

function toEventKey(event: UnrecognizedNotificationEvent): string {
  return `${event.eventType}:${event.itemId ?? ""}`;
}

export function useReportUnrecognizedNotificationEvents(events: UnrecognizedNotificationEvent[]): void {
  const reportedKeys = useRef<Set<string>>(new Set());

  useEffect(() => {
    for (const event of events) {
      const key = toEventKey(event);
      if (reportedKeys.current.has(key)) continue;
      reportedKeys.current.add(key);
      reportUnrecognizedNotificationEventType(event.eventType, event.itemId);
    }
  }, [events]);
}
